import {Contract, Document} from "core/document/documentDomain";
import {Movable} from "core/grid/gridUtils";
import {action, observable} from "mobx";
import {IDomainObject} from "core/form/formUtils";
import documentService from "core/document/documentService";
import {Party} from "party/partyDomain";


export interface GridDocumentsParams {
  partyId?: number;
  vehicleId?: number;
  productId?: number;
  contractId?: number;
  invoiceId?: number;
  shipmentId?: number;
}



export class GridDocument implements Movable {
  blockName: string;
  showContract: boolean;
  @observable params: GridDocumentsParams;
  @observable customer: Party;
  @observable documents: Document[];
  @observable contracts: Contract[];
  @observable $dirty: boolean;
  @observable label: string;

  constructor(blockName: string, label: string, params: GridDocumentsParams, showContract: boolean, customer: Party, documents: Document[]) {
    this.blockName = blockName;
    this.label = label;
    this.params = params;
    this.showContract = showContract;
    this.customer = customer;
    this.documents = documents;
  }

  public isEditable() {
    return false;
  }
  public isClientBlock() {
    return false;
  }

  public getBlockName() {
    return this.blockName;
  }

  @action search(dataObject: IDomainObject, refresh: boolean = true): Promise<any> {

    return Promise.all([documentService.readDocuments(this.params), (this.showContract && this.customer) ? documentService.readPartyContracts(this.customer.partyId) : Promise.resolve([]) ])
      .then( ([documents, contracts] : [Document[], Contract[]]) => {
        this.documents = documents;
        this.contracts = contracts;
      });
  }

  get data() {
    return this.documents;
  }

  set data(data: any) {
    this.documents = data;
  }

}



// WEBPACK FOOTER //
// ./src/core/document/gridDocument.ts